import { Injectable } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { ComposedChartRoutesAPI } from '../constants';
import { ChartFilter } from '../interfaces';

@Injectable({})
export class ComposedChartService {

  static total(filter: ChartFilter | undefined): Promise<string> {
    return HttpService.get(ComposedChartRoutesAPI.COMPOSED_CHART_TOTAL, filter)
      .then(response => {
        return response.body as string;
      });
  }

}
